<template>
	<div id="subpageDiv">
		<div class="subBanner" style="background:url(images/subBg07.png) center center no-repeat">
		    <div class="w1200">
		        <div class="subTitle">
		            <em>Policy Planning</em>
		            <span>政策法规</span>
		            <img src="/images/line.png" class="line"/>
		        </div>
		    </div>
		</div>
		<div class="w1200">
			<itemsearch v-bind:colid='colid' v-bind:colname='colname' @searchshow="searchshow" @searchclose="searchclose"></itemsearch>
			<div v-show="!searchResultShow">
		    <ul class="tab1">
					<li @click="searchClick('e826806f46294fd494cc35990a8698fa','最新政策')" :class="subcolid=='e826806f46294fd494cc35990a8698fa'?'curr':''"><span>最新政策</span></li>
					<li @click="searchClick('e694a278a1ce4a078be0e285d48a484e','政策动态')" :class="subcolid=='e694a278a1ce4a078be0e285d48a484e'?'curr':''"><span>政策动态</span></li>
					<li @click="searchClick('80fa3d5af7ca481a8a7b7d5db7e582dd','国家政策')" :class="subcolid=='80fa3d5af7ca481a8a7b7d5db7e582dd'?'curr':''"><span>国家政策</span></li>
					<li @click="searchClick('c7e2bb80073349c4b999cbb2f13a4937','地方政策')" :class="subcolid=='c7e2bb80073349c4b999cbb2f13a4937'?'curr':''"><span>地方政策</span></li>
					<li @click="searchClick('b7331a3e864346b6bce8641bb3272afa','国外政策')" :class="subcolid=='b7331a3e864346b6bce8641bb3272afa'?'curr':''"><span>国外政策</span></li>
				</ul>
		    <div id="con_a_1">
						<el-skeleton :rows="20" :loading="loadingMask" animated>
		        <ul class="newList">
		            <li v-for="(result,index) in resultDataList" >
		            	<router-link :to="{ name: 'detail', params: { id: result.id , toutiaoflag:(subcolid=='b7331a3e864346b6bce8641bb3272afa'?null:'1') }}" target="_blank" @click.native="$track([['pagetype',colname+'-文章-id:'+result.id+'-点击']])">
										<span v-if="result.articletype">【{{result.articletype}}】</span>{{result.title}}<i></i></router-link>
									<p v-if="subcolid=='b7331a3e864346b6bce8641bb3272afa'" :title="result.summary.indexOf('attachment id=')>-1?' ':result.summary">{{result.summary.indexOf('attachment id=')>-1?' ':result.summary}}</p>
		              <em>{{result.publishtime?result.publishtime.substring(0,10):''}}</em>
		            </li>
		        </ul>
						</el-skeleton>
		        <div class="pagediv">
		        	<el-pagination
		        				@size-change="changePageSize"
		        				@current-change="changeSearchPage"
		        				:current-page="pageNum"
		        				:page-sizes="[10, 15, 20]"
		        				:page-size="pageSize"
		        				layout="total, sizes, prev, pager, next, jumper"
		        				:total="totalResultCount">
		        			</el-pagination>
		        </div>
		    </div>
			</div>
		</div>
	</div>
</template>

<script>
	import itemsearch from '@/components/list-item-search.vue'
	export default {
		data() {
			return {
				loadingMask: true,
				colid:'e826806f46294fd494cc35990a8698fa',
				subcolid:'e826806f46294fd494cc35990a8698fa',
				colname:'政策法规',
				pageNum: 1,
				pageSize: 10,
				totalResultCount: 0,
				resultDataList: [],
				searchResultShow:false,
				searchKey:'',
			}
		},
		components:{
			itemsearch,
		},
		created:function(){
			
		},
		mounted:function(){
			document.title='政策-数字中国专版';
			// this.$track([
			// 	['pagetype','政策列表'],
			// 	['reqtype','2'],
			// 	['column',this.colid]
			// ]);
			// this.searchfnc();
			this.searchClick(this.subcolid);
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},
		methods: {
			searchfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'article/searchArticles',
						responseType: 'json',
						params: {
							columnID:this.subcolid,
							iPage: this.pageNum,
							pageSize: this.pageSize,
							orderBy:'publishtime',
							isDesc:'1',
						},
					})
					.then(function(response) {
						_this.resultDataList = response.data.data.data.data;
						_this.totalResultCount = response.data.data.data.totalcount;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			searchClick: function(columnid,columnname) {
				if (columnid) {
					this.subcolid=columnid;
					this.$track([
						['pagetype','政策列表'],
						['reqtype','2'],
						['column',this.subcolid]
					]);
					if(columnname){
						this.$track([
							['pagetype',this.colname+'-'+columnname+'-点击'],
						]);
					}
				}
				this.pageNum = 1;
				this.pageSize= 10;
				this.searchfnc();
			},
			changePageSize:function(pagesize){
				this.pageSize=pagesize;
				this.searchfnc();
			},
			changeSearchPage: function(page) {
				this.pageNum = page;
				this.searchfnc();
				document.body.scrollTop = document.getElementById('subpageDiv').offsetTop;
				document.documentElement.scrollTop = document.getElementById('subpageDiv').offsetTop;
			},
			searchshow:function(key){
				this.searchResultShow=true;
			},
			searchclose:function(){
				this.searchResultShow=false;
			}
		}
	}
</script>

<style>
</style>
